import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IEsocialData } from '../../interface/esocial';
import { IEsocialResponse } from '../../interface/response-esocial';

interface Events {
  kind: string;
  key: string;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class EventsService {
  private url = `${environment.url}/analysis/events`;

  constructor(private http: HttpClient) {}

  dispatchEvents(module: string, data: any): Observable<any> {
    return this.http.post<any>(`${environment.url}/${module}/events`, data).
    pipe(catchError(err => throwError(err)))
  }

  dispatchEventsSystem(module: string, data: any): Observable<any> {
    return this.http.post<any>(`${environment.url}/${module}/events`, data).
    pipe(catchError(err => throwError(err)))
  }

  selectDocument(key: string, button: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      {
        kind: 'document_select',
        key: '-',
        data: { document: key, button: button },
      },
    ]);
  }

  selectImage(key: string, button: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'image_select', key: '-', data: { image: key, button: button } },
    ]);
  }

  getNextImagesAnalysis(module: string): Observable<any> {
    return this.http.get<any>(`${environment.url}/${module}/next/images`);
  }

  getImageCookie(url: string) {
    return this.http.get(url);
  }

  changeFieldValue(key: string, value: any): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_change', key: key, data: { value: value } },
    ]);
  }

  startAnalysis(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'analysis_acknowledge', key: '-' },
    ]);
  }

  allowFieldChange(key: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_allow_change', key: key, data: {} },
    ]);
  }

  approveField(key: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_approved', key: key, data: {} },
    ]);
  }

  nextDocument(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'document_next', key: '-', data: {} },
    ]);
  }

  finishLoadImages(total: number): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'finish_load_images', key: '-', data: { total: total } },
    ]);
  }

  timeoutAnalysis(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'analysis_timeout', key: '-', data: {} },
    ]);
  }

  finishAnalysis(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'analysis_finish', key: '-', data: {} },
    ]);
  }

  withdrawalAnalysis(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'analysis_withdrawal', key: '-', data: {} },
    ]);
  }

  reproveImage(key, reasons, note): Observable<Events> {
    return this.http.post<Events>(this.url, [
      {
        kind: 'image_reprove',
        key: key,
        data: { reasons: reasons, note: note },
      },
    ]);
  }

  approveImage(key): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'image_approve', key: key, data: {} },
    ]);
  }

  esocialReprove(reasons, automatic): Observable<Events> {
    return this.http.post<Events>(this.url, [
      {
        kind: 'esocial_reprove',
        key: '-',
        data: { reasons: reasons, automatic: automatic },
      },
    ]);
  }

  esocialApprove(automatic): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'esocial_approve', key: '-', data: { automatic: automatic } },
    ]);
  }

  esocialSkip(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'esocial_skip', key: '-', data: {} },
    ]);
  }

  esocialAutoValidate(data: IEsocialData): Observable<IEsocialResponse> {
    const url = `${environment.url}/api/analysis/automation/esocial`;
    return this.http.post<IEsocialResponse>(url, data);
  }
}
